import React from 'react';
import s from '../s.module.less';

// 绿色状态眉标：确认区的 Received by Klarity、saved 屏的 Draft saved 共用
export default function StatusEyebrow({ label }: { label: string }) {
    return (
        <div className={s.statusEyebrow}>
            <span className={s.statusEyebrowIcon}>&#10003;</span>
            {label}
        </div>
    );
}
